import React from "react";
import Entity from "student-front-commons/src/components/Entity";
import StudentCourseList from "./StudentCourseList";

const StudentCourseListContainer = () => (
  <Entity name="course">{({ getAll: getAllCourse }) => <StudentCourseList courses={getAllCourse()} />}</Entity>
);

export default StudentCourseListContainer;
